// extracted by mini-css-extract-plugin
export default {"searchBox":"by_gL","resultsOpen":"by_gM"};